import {
  Button,
  Input,
  Label,
  ModalPortal,
  P1,
  P2,
  SelectInput,
  SelectOption,
  Table,
  TableData,
  TableHeader,
  TextButton,
} from "components"
import { Eye, Image, Trash } from "iconsax-react"
import React, { useState, useRef } from "react"
import { Form, useAppNotificationStore, useAuthStore } from "stores"
import { OLevelResult, useApplicationStore } from "stores/application"
import { BASEURL, throttle } from "utils"

export const UploadOlevelResults: React.FC<{}> = () => {
  const {
    dateRanges,
    addOLevelResult,
    getDateRange,
    oLevelResults,
    deleteOLevelResult,
    getOLevelResults,
  } = useApplicationStore()
  const { toast } = useAppNotificationStore()
  const uploadimage = useRef(null)
  const [showResult, setShowResult] = useState(false)
  const [resultToShow, setResultToShow] = useState<OLevelResult>()
  const [olevelResultsUploads, setOlevelResultsUploads] =
    useState<OLevelResult[]>()

  const [olevelResultForm, setOlevelResultForm] = useState(
    new Form({
      examName: "",
      examNumber: "",
      examYear: "",
      subjects: [],
      file: "",
    })
  )
  const handleValueChange = (value: any, key: string) => {
    olevelResultForm.setCredential(key, value)

    setOlevelResultForm(new Form(olevelResultForm.credentials))
  }

  const isLoading = (status: boolean) => {
    if (status) {
      const uptateDom = new Form(olevelResultForm.credentials)
      uptateDom.loading(true)
      setOlevelResultForm(uptateDom)
    } else {
      const uptateDom = new Form(olevelResultForm.credentials)
      uptateDom.loading(false)
      setOlevelResultForm(uptateDom)
    }
  }

  const initializePage = React.useCallback(async () => {
    try {
      await getOLevelResults()
      await getDateRange()
    } catch (error) {
      console.log(error)
      toast.error("Unable to get qualifications")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast, olevelResultForm])

  React.useEffect(() => {
    return throttle(() => {
      initializePage()
    })
  }, [initializePage])

  React.useEffect(() => {
    setOlevelResultsUploads(oLevelResults!)
  }, [oLevelResults])

  const handleSubmit = (e: any) => {
    e.stopPropagation()
    e.preventDefault()

    if (!(olevelResultForm.credentials as any).result) {
      toast.error("Result required.")
      return
    }
    isLoading(true)
    try {
      handleFileUpload((olevelResultForm.credentials as any).result).then(
        async (resp) => {
          if (resp.isSuccessful === true) {
            await addOLevelResult({
              examName: olevelResultForm.credentials.examName,
              examNumber: olevelResultForm.credentials.examNumber,
              examYear: olevelResultForm.credentials.examYear,
              resultPath: resp.data.fullPath,
              subjects: [],
            }).then((resp) => {
              isLoading(false)
              if (resp.isSuccessful === true) {
                toast.success(resp.message)
                setOlevelResultForm(
                  new Form({
                    examName: "",
                    examNumber: "",
                    examYear: "",
                    subjects: [],
                    file: "",
                  })
                )
              } else {
                toast.error(resp.message)
              }
            })
          } else {
            isLoading(false)
            toast.error(resp.message)
          }
        }
      )
    } catch (error: any) {
      isLoading(false)
      toast.error(error?.message as string)
    }
  }

  const handleFileUpload = async (inputFile: any) => {
    const formData = new FormData()
    formData.append("documentType", "OlevelResult")
    formData.append("file", inputFile)
    return await fetch(`${BASEURL}/api/Utility/upload`, {
      method: "post",
      body: formData,
      headers: { ...useAuthStore.getState().getAuthHeader() },
    }).then((resp) => resp.json())
  }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="w-full lg:w-[536px] flex flex-col gap-8"
        encType="multipart/form-data"
      >
        <div className="space-y-[5px] w-full">
          <Label
            htmlFor="examName"
            aria-required
          >
            Exam Name
          </Label>
          <SelectInput
            id="examName"
            name="examName"
            required
            disabled={olevelResultForm.isSubmitting}
            placeholder="Select Exam name"
            onChange={(e) => handleValueChange(e.target.value, e.target.name)}
          >
            {["WAEC", "NECO", "NABTEB"].map((option, index) => (
              <SelectOption
                key={index}
                value={option}
                selected={
                  option ===
                  olevelResultForm.credentials?.examName?.toUpperCase()
                }
              >
                {option}
              </SelectOption>
            ))}
          </SelectInput>

          <div className="space-y-[5px] w-full flex justify-between items-center gap-3">
            <div className="w-full">
              <Label
                htmlFor="examNumber"
                aria-required
              >
                Exam Number
              </Label>
              <Input
                id="examNumber"
                name="examNumber"
                required
                disabled={olevelResultForm.isSubmitting}
                placeholder="Enter your exam number"
                value={olevelResultForm.credentials.examNumber}
                onChange={(e) =>
                  handleValueChange(e.target.value, e.target.name)
                }
              />
            </div>
            <div className="w-full">
              <Label
                htmlFor="examYear"
                aria-required
              >
                Exam Year
              </Label>
              <SelectInput
                id="examYear"
                name="examYear"
                required
                disabled={olevelResultForm.isSubmitting}
                placeholder="Select exam year"
                value={olevelResultForm.credentials.examYear}
                onChange={(e) =>
                  handleValueChange(e.target.value, e.target.name)
                }
              >
                {dateRanges.endDate.map((option, index) => (
                  <SelectOption
                    key={index}
                    value={option}
                  >
                    {option}
                  </SelectOption>
                ))}
              </SelectInput>
            </div>
          </div>
        </div>

        <div className="space-y-[5px] w-full flex justify-between items-center gap-3">
          <div className="w-full">
            <Label
              htmlFor="examNumber"
              aria-required
            >
              Upload Result
            </Label>

            {/* <ChooseFile  onClicl/> */}

            <div
              className="w-full h-40 border border-dashed border-accentIcon2 rounded-xl flex flex-col justify-center items-center gap-4 p-10 lg:p-8"
              onClick={() => {
                uploadimage.current && (uploadimage.current as any).click()
              }}
            >
              <Image className="text-pryBase rounded-md border-2 border-pryBase min-w-[36px] min-h-[36px] w-9 h-9 p-0" />

              {(olevelResultForm.credentials as any).result ? (
                <P2 className="text-accentText font-medium text-center">
                  {(olevelResultForm.credentials as any).result.name}
                </P2>
              ) : (
                <P2 className="text-accentText font-medium text-center">
                  Drop your image here, or{" "}
                  <label
                    htmlFor="file"
                    className="text-pryBase cursor-pointer"
                  >
                    browse
                  </label>{" "}
                  <br />
                  <span className="text-accentGrey2">
                    JPG,PNG and JPEG files are allowed(max file size of 4MB)
                  </span>
                </P2>
              )}
            </div>

            <input
              type="file"
              style={{
                display: "none",
              }}
              ref={uploadimage}
              accept="image/*"
              name="result"
              onChange={(e) => {
                const inputFile = e.target.files?.[0]
                if (inputFile) {
                  handleValueChange(inputFile, e.target.name)
                }
              }}
            />
          </div>
        </div>

        <div className="flex justify-end">
          <Button
            type="submit"
            title={"Add Record"}
            color="primary"
            className="w-52"
            disabled={olevelResultForm.isLoading}
            submitting={olevelResultForm.isLoading ? "true" : "false"}
          >
            {"Save Result"}
          </Button>
        </div>
      </form>
      <div className="w-full lg:w-[536px] flex flex-col gap-0.5">
        {olevelResultsUploads?.length === 0 ? (
          <P1 className="text-accentGrey1">No O'level results yet.</P1>
        ) : (
          <div className="w-full">
            <Table
              cols={5}
              headers={[
                <TableHeader>#</TableHeader>,
                <TableHeader>Exam&nbsp;Type</TableHeader>,
                <TableHeader>Exam&nbsp;Number</TableHeader>,
                <TableHeader>Year</TableHeader>,
                <TableHeader>Action</TableHeader>,
              ]}
              rows={oLevelResults.map((record, index) => ({
                data: [
                  <TableData key={index}>{index + 1}</TableData>,
                  <TableData key={index}>{record.examName}</TableData>,
                  <TableData key={index}>{record.examNumber}</TableData>,
                  <TableData key={index}>{record.examYear}</TableData>,
                  <div className="flex gap-2 justify-center">
                    <TextButton
                      type="button"
                      title="View"
                      className="flex gap-3 items-center"
                      onClick={() => {
                        setShowResult(true)
                        setResultToShow(record)
                      }}
                    >
                      <Eye
                        className="text-accentText"
                        size={18}
                      />
                    </TextButton>
                    <TextButton
                      type="button"
                      title="View"
                      className="flex gap-3 items-center text-stateError"
                      onClick={async () => {
                        await deleteOLevelResult({
                          resultId: record.resultId,
                        }).then((resp) => {
                          if (resp.isSuccessful === true) {
                            toast.success(resp.message)
                          } else {
                            toast.error(resp.message)
                          }
                        })
                      }}
                    >
                      <Trash size={18} />
                    </TextButton>
                  </div>,
                ],
              }))}
            />
            <br />
          </div>
        )}
      </div>
      {showResult && resultToShow && (
        <ModalPortal
          width={200}
          close={() => {
            setShowResult(false)
          }}
        >
          <div
            style={{
              overflow: "scroll",

              marginBottom: "20px",
            }}
          >
            <img
              src={resultToShow?.resultPath}
              alt=""
            />
          </div>
        </ModalPortal>
      )}
    </>
  )
}
